import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { KEY_CODE } from '@commoncore/services/universal.service';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'app-cancel-all-uploads',
  templateUrl: './cancel-all-uploads.component.html',
  styleUrls: ['./cancel-all-uploads.component.scss'],
  imports:[DependenciesModule]
})
export class CancelAllUploadsComponent implements OnInit {
  @Input() showCancelAllUploads:boolean;
  @Output() confirmCancel = new EventEmitter();
  public selectedOption :string="continue"

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.cancelUploads(false);
    }else if (event.key === "Enter" && this.selectedOption == "continue"){
      this.cancelUploads(false);
    }else if (event.key === "Enter" && this.selectedOption == "cancel"){
      this.cancelUploads(true);
    }

    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      $('#btn-cancel').addClass('no-bg');
      $('#btn-continue').removeClass('no-bg');
      this.selectedOption = "continue"
    }

    if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      $('#btn-cancel').removeClass('no-bg');
      $('#btn-continue').addClass('no-bg');
      this.selectedOption = "cancel"
    }
  }

  constructor() { }

  ngOnInit(): void {

    $('#btn-continue').removeClass('no-bg');
    $('#btn-cancel').addClass('no-bg');
  }

  cancelUploads(type){
    this.confirmCancel.emit(type)
  }

}
